import { EyeIcon } from '@phosphor-icons/react'

import { Actions } from '@components/shared/Actions'
import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'
import { OcNfStatus } from '../components/OcNfStatus'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { OcNfModalPurchaseOrdersProps } from '../context/types'
import type { StatusProps } from '../components/OcNfStatus/types'

interface ParseDetailedSummaryProps {
  data: OcNfModalPurchaseOrdersProps[]
  onViewMore: (item: OcNfModalPurchaseOrdersProps) => void
}

export const parseOcNfDetailsGrid = ({ data, onViewMore }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'purchaseOrder',
      columnName: 'Ordem Compra',
      value: item.purchaseOrderNumber || '-',
      align: 'center',
      minWidth: '11rem',
      sortable: true,
      stickyPosition: 'left'
    },
    {
      id: 'expectedDate',
      columnName: 'Data Prevista',
      align: 'center',
      value: item.expectedDate ? formattedDatePtBr(item.expectedDate) : '-',
      minWidth: '10rem',
      sortable: true
    },
    {
      id: 'itemsOcQuantity',
      columnName: 'Qtd. Itens OC',
      align: 'center',
      value: item.purchaseOrderItemCount || '-',
      minWidth: '10rem',
      sortable: true
    },
    {
      id: 'totalValueOc',
      columnName: 'Valor Total OC',
      align: 'center',
      value: item.purchaseOrderTotalAmount || 0,
      currency: true,
      minWidth: '10rem',
      sortable: true
    },
    {
      id: 'statusOc',
      columnName: 'Status OC',
      align: 'center',
      minWidth: '8rem',
      sortable: true,
      withoutTooltip: true,
      value: item.status ? <OcNfStatus status={item.status as StatusProps} /> : '-'
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Actions actions={[{ label: 'Detalhes OC', icon: <EyeIcon size={18} />, onClick: () => onViewMore(item) }]} />
      )
    }
  ])

  return parsedData
}
